export const formatToDate = (timestamp) => {
    const date = new Date(timestamp).toLocaleDateString();
    const time = new Date(timestamp).toLocaleTimeString();
    return `${date} ${time}`;
};
